"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTROLLED_PRESCRIPTION_NUMBERING_LABELS = exports.ControlledPrescriptionNumbering = exports.controlledPurchaseLineInvoiceAt = exports.controlledPurchaseLineKey = exports.CONTROLLED_PURCHASE_LINE_STATE_LABELS = exports.CONTROLLED_PURCHASE_LINES_REQUIRED_FROM = exports.ControlledPurchaseLineState = void 0;
var ControlledPurchaseLineState;
(function (ControlledPurchaseLineState) {
    /** Invoiced by the supplier and no receta covers it. */
    ControlledPurchaseLineState["pending"] = "pending";
    /** Not invoiced yet: the receta waits for the supplier's invoice, and nothing waits for it. */
    ControlledPurchaseLineState["awaiting_invoice"] = "awaiting_invoice";
    /** A receta not yet emitted covers it. */
    ControlledPurchaseLineState["in_prescription"] = "in_prescription";
    /** The receta has a SITPV folio. */
    ControlledPurchaseLineState["emitted"] = "emitted";
    /** The receta's additional info was saved and the receta closed on the portal. */
    ControlledPurchaseLineState["declared"] = "declared";
    /**
     * Bought before {@link CONTROLLED_PURCHASE_LINES_REQUIRED_FROM} and never covered: that period is closed
     * (Javier, 2026-09-19: «ya fueron… deja de ser nuestro problema»). Visible, never pending.
     */
    ControlledPurchaseLineState["historical"] = "historical";
    /** Fully cancelled by a return to the supplier: nothing left to cover. */
    ControlledPurchaseLineState["returned"] = "returned";
})(ControlledPurchaseLineState || (exports.ControlledPurchaseLineState = ControlledPurchaseLineState = {}));
/**
 * From this albarán date on, every controlled purchase needs a receta from the app. Earlier ones are linked when a
 * portal receta covered them, and otherwise stay «historical» (2026-09-01, Mexico midnight).
 */
exports.CONTROLLED_PURCHASE_LINES_REQUIRED_FROM = '2026-09-01T06:00:00.000Z';
exports.CONTROLLED_PURCHASE_LINE_STATE_LABELS = {
    [ControlledPurchaseLineState.pending]: 'Por recetar',
    [ControlledPurchaseLineState.awaiting_invoice]: 'Sin factura del proveedor',
    [ControlledPurchaseLineState.in_prescription]: 'En receta',
    [ControlledPurchaseLineState.emitted]: 'Emitida',
    [ControlledPurchaseLineState.declared]: 'Declarada',
    [ControlledPurchaseLineState.historical]: 'Histórico sin receta',
    [ControlledPurchaseLineState.returned]: 'Devuelta',
};
/** `${qvetCode}@${albaranAt ISO}`. */
const controlledPurchaseLineKey = (qvetCode, albaranAt) => `${qvetCode}@${new Date(albaranAt).toISOString()}`;
exports.controlledPurchaseLineKey = controlledPurchaseLineKey;
/**
 * The date that decides a line's month: the supplier's invoice. `null` when there is none yet — the line is not ours
 * to prescribe until the supplier invoices it.
 */
const controlledPurchaseLineInvoiceAt = (l) => l.invoiceAt && String(l.supplierInvoice ?? '').trim() ? l.invoiceAt : null;
exports.controlledPurchaseLineInvoiceAt = controlledPurchaseLineInvoiceAt;
/**
 * Which numbering a receta belongs to — stored on the receta (Javier, 2026-09-19: «que se guarde y se refleje si es vieja
 * o nueva»). Before SENASICA's electronic system (June 2026) recetas carried our own paper numbering (nº 163–227); since
 * then the number is the portal folio (000001…). A proposal belongs to `sitpv`: it takes a folio when emitted.
 */
var ControlledPrescriptionNumbering;
(function (ControlledPrescriptionNumbering) {
    ControlledPrescriptionNumbering["legacy"] = "legacy";
    ControlledPrescriptionNumbering["sitpv"] = "sitpv";
})(ControlledPrescriptionNumbering || (exports.ControlledPrescriptionNumbering = ControlledPrescriptionNumbering = {}));
exports.CONTROLLED_PRESCRIPTION_NUMBERING_LABELS = {
    [ControlledPrescriptionNumbering.legacy]: 'Anterior a SITPV',
    [ControlledPrescriptionNumbering.sitpv]: 'SITPV',
};
